import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'

export default function PrivacyModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose}
      />

      {/* modal */}
      <div className="relative bg-white rounded-lg shadow-lg max-w-xl w-full p-6 overflow-y-auto max-h-[90vh]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Privacy Policy</h2>
          <button onClick={onClose}>
            <XMarkIcon className="w-6 h-6 text-gray-700 hover:text-gray-900" />
          </button>
        </div>
        <div className="text-gray-700 text-sm space-y-4">
          <p><strong>Last updated:</strong> April 29, 2025</p>
          <p>Welcome to MyEventMitra. We respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy explains:</p>
          <ol className="list-decimal pl-5 space-y-2">
            <li>
              <strong>Information We Collect</strong><br/>
              • Personal Data: name, email, phone number, event details, profile image URL, newsletter subscription.<br/>
              • Usage Data: pages visited, button clicks, form submissions, device/browser details, IP address.<br/>
              • Cookies &amp; Tracking: we use cookies and similar technologies to remember preferences and analyze site usage.
            </li>
            <li>
              <strong>How We Use Your Information</strong><br/>
              • To provide and improve our services (matching vendors, sending newsletters).<br/>
              • To communicate with you (confirmations, support responses).<br/>
              • To personalize content and recommendations.<br/>
              • To analyze trends and monitor site performance.<br/>
              • To comply with legal obligations.
            </li>
            <li>
              <strong>How We Share Your Information</strong><br/>
              • With Vendors: your submitted event requests (only with your consent).<br/>
              • Service Providers: hosting, analytics, email delivery (under strict confidentiality).<br/>
              • Legal Requirements: when required by law or to protect our rights.
            </li>
            <li>
              <strong>Your Choices</strong><br/>
              • Access &amp; Correction: you can review or update your personal data via your account page.<br/>
              • Marketing Opt-Out: unsubscribe from our newsletter at any time via the link in our emails or footer form.<br/>
              • Cookies: you may disable cookies in your browser settings (note this may affect site functionality).
            </li>
            <li>
              <strong>Security</strong><br/>
              We implement industry-standard measures (encryption, secure storage, access controls) to protect your data.
            </li>
            <li>
              <strong>Children’s Privacy</strong><br/>
              Our services are not intended for users under 13. We do not knowingly collect data from children.
            </li>
            <li>
              <strong>Changes to This Policy</strong><br/>
              We may update this policy. If significant changes occur, we’ll post a notice on our site.
            </li>
            <li>
              <strong>Contact Us</strong><br/>
              If you have any questions, please email <a href="mailto:info@myeventmitra.com" className="text-orange-600 hover:underline">info@myeventmitra.com</a>.
            </li>
          </ol>
        </div>
      </div>
    </div>
  )
}